import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type StoreService from 'ember-data/store';
import type PersonModel from 'tio-common/models/person';

export default class AuthenticatedCareerPathwaysFinanceHistoryRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const personId = this.sessionContext.user.person.id;

    const [contributionHistory, employerContributions, dataSourceInfo, person] = await Promise.all([
      this.reimaginedData.fetchContributionHistory(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.getDataSourceInfo(),
      // @ts-expect-error type models
      this.store.findRecord<PersonModel>('person', personId, {
        include: 'accounts.financial-institution,accounts.loans',
        reload: true,
      }),
    ]);

    return {
      contributionHistory,
      employerContributions,
      dataSourceInfo,
      person,
    };
  }
}
